import { useEffect } from 'react';

import { useApplicationContext } from '../../../utils/applicationContext';
import { generateSmartContactPixelUrl } from './generateSmartContactPixelUrl';

export const useSmartContactPixel = () => {
  const { config } = useApplicationContext();
  const pixelId = config.getStrict<string>('smartContact.pixelId');

  useEffect(() => {
    const scriptTag = document.createElement('script');
    scriptTag.defer = true;
    scriptTag.src = generateSmartContactPixelUrl(pixelId, 'visit', 'select_realtor_promo');
    document.body.appendChild(scriptTag);

    return () => {
      document.body.removeChild(scriptTag);
    };
  }, [pixelId]);
};
